import ContentHeader from '@Components/ContentHeader'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'

const DashboardContentHeader = () => {
    const { rightsholderStore } = useContext(StoresContext)
    return <ContentHeader title={rightsholderStore.memberSummary.name} />
}

export default DashboardContentHeader
